// TEI Client Utilities
// HTTP utilities for Text Embeddings Inference API

const DEFAULT_ENDPOINT = 'http://localhost:8080'

/**
 * Create TEI utilities
 * @param {Function} httpRequest - HTTP request function
 * @returns {Object} Object with requestAPI and checkAvailability functions
 */
export function createTeiUtils(httpRequest) {
  const requestAPI = async ({
    endpoint = DEFAULT_ENDPOINT,
    path,
    method = 'POST',
    body = {},
    timeout = 30000,
  }) => {
    const url = new URL(endpoint)
    const protocol = url.protocol.replace(':', '')
    const host = url.hostname
    const port = url.port || (protocol === 'https' ? 443 : 80)

    const options = {
      protocol,
      options: {
        host,
        port: parseInt(port, 10),
        path,
        method,
        headers: {
          'Content-Type': 'application/json',
        },
        timeout,
      },
      data: method === 'POST' || method === 'PUT' ? JSON.stringify(body) : '',
    }

    try {
      const resp = await httpRequest(options)

      if (resp.statusCode >= 400) {
        throw new Error(`TEI API error: ${resp.statusCode} - ${resp.body}`)
      }

      return JSON.parse(resp.body)
    } catch (error) {
      if (error.code === 'ECONNREFUSED' || error.message.includes('connect')) {
        throw new Error(
          `Cannot connect to TEI at ${endpoint}. Make sure TEI is running.`,
        )
      }
      throw error
    }
  }

  const checkAvailability = async (endpoint = DEFAULT_ENDPOINT) => {
    try {
      const url = new URL(endpoint)
      const protocol = url.protocol.replace(':', '')
      const host = url.hostname
      const port = url.port || (protocol === 'https' ? 443 : 80)

      const resp = await httpRequest({
        protocol,
        options: {
          host,
          port: parseInt(port, 10),
          path: '/health',
          method: 'GET',
          timeout: 3000,
        },
        data: '',
      })

      return resp.statusCode === 200
    } catch (error) {
      return false
    }
  }

  return { requestAPI, checkAvailability }
}
